import { Box, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AndroidStoreIcon, AppStoreIcon } from '../../../shared/ui/Icons'
import { useMobileAppContent } from '@/shared/hooks'
import { Link } from 'react-router-dom'

const MobileAppContent = () => {
    const { t: translate } = useTranslation()
    const { containerStyle, downloadAppStatement, userUseIOS, userUseAndroid } =
        useMobileAppContent()

    const imageContainer = {
        width: '45%',
        height: '80px',

        'a > svg': {
            height: '80px',
            width: '120px',
        },
    }

    return (
        <Box sx={containerStyle}>
            <Box sx={imageContainer}>
                <Link to="https://play.google.com/">
                    {userUseAndroid && <AndroidStoreIcon />}
                </Link>
                <Link to="https://www.apple.com/app-store/">
                    {userUseIOS && <AppStoreIcon />}
                </Link>
            </Box>
            <Typography sx={downloadAppStatement}>
                {translate('downloadAppStatement')}
            </Typography>
        </Box>
    )
}

export { MobileAppContent }
